import React, { Component } from 'react';
import { Pagination as UIKitPagination } from '@creditcards/ui-kit-react';
import style from './style.module.css';

class Pagination extends Component {
  render() {
    return (
      <div className={style.pagination}>
        <UIKitPagination {...this.props} />
      </div>
    );
  }
}

export default Pagination;
